import { render, staticRenderFns } from "./ActiveCoursePage.vue?vue&type=template&id=58660b46&scoped=true&"
import script from "./ActiveCoursePage.vue?vue&type=script&lang=js&"
export * from "./ActiveCoursePage.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCoursePage.vue?vue&type=style&index=0&id=58660b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58660b46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
